<template>
  <span>
      
    <el-button icon=""
            style="padding:0 .1rem" size="small" type="text" @click="analysisDetailFlag = true;formInline = row;getList()"
      >考核分析</el-button
    >
    <el-dialog title="考核分析" 
    :close-on-click-modal="false" 
    :visible.sync="analysisDetailFlag" append-to-body width="65%">
      <div>
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <el-row>
                  <el-col :span="8">
              <el-form-item label="任务名称：">
                <el-input v-model="formInline.name" :disabled="true" placeholder="任务名称"></el-input>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="考核对象：">
                <el-input v-model="formInline.standardName" :disabled="true" placeholder="考核对象"></el-input>
              </el-form-item></el-col>
                  <el-col :span="8">
              <el-form-item label="标准名称：">
                <el-input v-model="formInline.standardName" :disabled="true" placeholder="标准名称"></el-input>
              </el-form-item></el-col>
              
              </el-row>
              <el-row>
              <el-form-item label="完成情况：">
                <el-input v-model="formInline.performance" :disabled="true" placeholder="完成情况"></el-input>
              </el-form-item>
              </el-row>
              <!-- <el-form-item>
                <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
              </el-form-item> -->
          </el-form>
        </div>
        <div>
          <!-- <el-button @click="handleAddClick('add','')" type="primary" size="small"
            >新增整改记录</el-button
          > -->
            <addLogForm ref="addLogForm" @onLoad="onLoad" :projectId="row.projectId" :standardList="tableData_" :row="row"></addLogForm>
        </div>
        <div>
          <el-table :data="tableData"
          border
           height="300"
          @selection-change="handleSelectionChange">
            <el-table-column
            
            align="center"
            header-align="center"
            type="selection"
            width="55">
            </el-table-column>
            <el-table-column 
            align="center"
            header-align="center"
            label="#" type="index"> </el-table-column>
            <el-table-column prop="content" label="标准内容" width="280"> </el-table-column>
            <el-table-column prop="demand" label="考核要求" width="180"> </el-table-column>
            <el-table-column prop="score" label="分值"> </el-table-column>
            <el-table-column prop="baseScore" label="基准分值"> </el-table-column>
            <el-table-column prop="averageScore" label="平均得分"> 
              
              <template slot-scope="scope"><span 
                style="color:red;"
                v-if="(scope.row.averageScore+'')&&(parseInt(scope.row.averageScore)<parseInt(scope.row.baseScore))" 
                >{{scope.row.averageScore}}</span><span
                  v-else
                >{{scope.row.averageScore}}</span></template>
            </el-table-column>
            <el-table-column 
            align="center"
            header-align="center" fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    
    <el-dialog title="详情" 
    :close-on-click-modal="false"
    :visible.sync="analysisListDetailFlag" append-to-body width="65%">
        
          <el-table border :data="tableDataDetail" height="300">
            <el-table-column 
            align="center"
            header-align="center"
            label="#" type="index"> </el-table-column>
            <el-table-column prop="deptName" label="填报部门" width="280"> </el-table-column>
            <el-table-column prop="userName" label="填报人员" width="180"> </el-table-column>
            <el-table-column prop="fillScore" label="得分"> </el-table-column>
            <el-table-column prop="fillTime" label="提交时间"> </el-table-column>
            <el-table-column prop="description" label="描述"> </el-table-column>
          </el-table>
    </el-dialog>
  </span>
</template>

<script>
import { getAnalyseTaskStandardDetail,getFillScoreByTaskIdAndStandardDetailId } from '@/api/v4ward/assess/task/assesstask';

  import addLogForm from "./examinereportrectify-form.vue";
export default {
    components:{
      addLogForm
    },
  props: {
    query: {
      default: ()=>{}, //项目id
    },
    row: {
      default: ()=>{}, //项目id
    },
  },
  data() {
    return {
        analysisListDetailFlag:false,
      analysisDetailFlag: false,
      tableData:[],
      tableData_:[],
      tableDataDetail:[],
      formInline: {
          user: '',
          region: ''
        }
    };
  },
  methods: {
      handleSelectionChange(rows){
          console.log(rows);
          this.tableData_ = rows;
      },
      onLoad(){},
    handleClick(row) {
      console.log(row);
    //   taskId,standardDetailId 
    let taskId = this.row.id;
    this.analysisListDetailFlag = true;
      getFillScoreByTaskIdAndStandardDetailId({standardDetailId:row.id,taskId:taskId}).then((res)=>{
          this.tableDataDetail = res.data;
      })
    }, 
    handleAddClick(type,row){
        console.log(row);
        
          // 查看
        //   handleOpenFormDialog(row,type){
            this.$refs.form.openDialog(type,row)
        //   },
    },
    onSubmit() {
        console.log('submit!');
    },
    getList(){
        let taskId = this.row.id;
        getAnalyseTaskStandardDetail({taskId:taskId}).then((res)=>{
            this.tableData = res.data;
        });
    },
  },
};
</script>

<style>
</style>